import Table, { getSTTCellData, formatValueToMoneyVND } from "components/Common/Table";
import { Button } from "reactstrap";

const Index = ({
  paging,
  setPaging,
  data,
  pageSize,
  setIsOpenModalDetail,
  setSiteCodeDetail,
}) => {
  return (
    <Table
      paging={paging}
      setPaging={setPaging}
      data={data}
      pageSize={pageSize}
      columns={[
        {
          Header: "STT",
          accessor: "",
          width: 50,
          Cell: data => (
            <div className="d-flex w-100 justify-content-center">
              {getSTTCellData(data, paging)}
            </div>
          ),
        },
        {
          Header: "LocationTypeCode",
          accessor: "masterLocationType",        
          width: 150,
        },
        {
          Header: "MasterLocationTypeName",
          accessor: "masterLocationTypeName",
          width: 350,
        },
        {
          Header: "Sum of Doanh Số",
          accessor: "sumOfDoanhSo",
          width: 250,
          Cell: ({ value }) => (   
            <div className="d-flex w-100 justify-content-end">
              {formatValueToMoneyVND(value)}
            </div>
        ),
        },
        {
          Header: "Action",
          width: 50,
          Cell: data => (
            <Button
              className="d-flex w-100 justify-content-center"
              color="link"
              onClick={e => {
                setSiteCodeDetail(data.original);
                setIsOpenModalDetail(true);
              }}
            >
              Chi tiết
            </Button>
          ),
        },
      ]}
      disablePagination={false}
    />
  );
};

export default Index;
